import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aha-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  currentYear;

  constructor() { }

  ngOnInit() {
    this.currentYear = new Date().getFullYear()
  }

}



// WEBPACK FOOTER //
// ./src/app/footer/footer.component.ts